import styled from "styled-components";

export const StyledHistoryTechSkill = styled.div`
  height: 100%;

  & .align-link-attach {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 15px;
  }

  & .empty-content {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  & .filters {
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 20px;
  }

  & .loader {
    padding-top: 25%;
  }

  & .empty-message-container {
    display: flex;
    justify-content: center;
  }
`;
